export function stringifyStructuredFieldDefinition(fieldData: {tableName: string; name: string}): string {
  return JSON.stringify([fieldData.tableName, fieldData.name]);
}
